<template>
  <v-card class="sim-composer pa-4" elevation="1">
    <div class="sim-composer__title">Reply as participant</div>
    <v-textarea
      v-model="text"
      placeholder="Type a reply (e.g. Y, N, STOP, HELP, or free text)"
      rows="2"
      outlined
      dense
      hide-details
      :disabled="sending"
      class="mb-3"
    />
    <div class="sim-composer__chips mb-3">
      <v-chip
        v-for="q in quickReplies"
        :key="q"
        class="mr-2 mb-2"
        small
        outlined
        :disabled="sending"
        @click="send(q)"
      >
        {{ q }}
      </v-chip>
    </div>
    <div class="d-flex justify-end">
      <v-btn
        color="primary"
        :disabled="!text || sending"
        :loading="sending"
        rounded
        elevation="0"
        @click="send(text)"
      >
        Send reply
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'SimulatorComposer',
  props: {
    sending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      text: '',
      quickReplies: ['Y', 'N', 'STOP', 'HELP'],
    }
  },
  methods: {
    send(body) {
      if (!body) return
      this.$emit('send', body)
      this.text = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.sim-composer {
  &__title {
    font-weight: 600;
    margin-bottom: 8px;
  }
}
</style>
